module.exports = __webpack_public_path__ + "static/carbon-table-compact-d3e73c038690f9bc1f7d253c3f1eaf96.png";